<template>
  <div>
    <v-app>
      <resizable-page>
        <template v-slot:table="tableProps">
          <v-card>
            <!-- <v-card-title>
     Procurement Order List
    </v-card-title> -->
            <v-card-title>
              <v-btn
                color="primary"
                dark
                class="ma-2"
                @click="addData"
                v-if="role.create"
              >
                Add Payment
              </v-btn>
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    class="ma-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Export To XLS
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <!-- <downloadExcel
                      class="btn"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch="
                        () => {
                          return dataExportBefore('all');
                        }
                      "
                    >
                      All Record
                    </downloadExcel> -->
                    <div class="btn" @click="exportAllXls()"> All Record </div>
                    <downloadExcel
                      hidden
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch="
                        () => {
                          return dataExport(exportAllData);
                        }
                      "
                    >
                     <button type="button" 
                      ref="btnDownloadAllExcell" class="btn"></button>
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item>
                    <downloadExcel
                      class="btn"
                      :data="exportDisplayedPage"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                    >
                      Displayed record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item v-if="(searchValue && searchCategory) || valuePaymentType || date_range_list">
                  <div class="btn" @click="exportAllFilteredXls()"> All filtered record </div>
                    <downloadExcel
                      hidden
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch="
                        () => {
                          return dataExport(exportAllData);
                        }
                      "
                    >
                     <button type="button" 
                      ref="btnDownloadAllFilteredExcell" class="btn"></button>
                    </downloadExcel>
                    <!-- <downloadExcel
                      class="btn"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch="
                        () => {
                          return dataExportBefore('filter');
                        }
                      "
                    >
                      All filtered record
                    </downloadExcel> -->
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-spacer></v-spacer>
              <div class="d-flex flex-wrap">
                <!-- filter date -->
                <v-menu
                  :key="componentKeyMenuRange"
                  ref="menu_range"
                  v-model="menu_range"
                  :close-on-content-click="false"
                  :return-value.sync="date_range_list"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date_range_list_show"
                      label="Payment date range"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      class="shrink"
                      style="margin-top: 8px;"
                    ></v-text-field>
                    <v-btn  :style="{display: clearButtonDateRange}"  @click="clearDateRangeButton" class="mt-5 ml-1" dark small color="red" >Clear</v-btn>
                  </template>
                  <v-date-picker 
                    v-model="date_range_list"
                    range
                    no-title
                    scrollable
                    show-adjacent-months
                    :show-current="date_list"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_range = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_range.save(date_range_list);changeDateRange();"
                    >
                      OK
                      </v-btn>
                    </v-date-picker>
                    
                  </v-menu>
                <v-select
                  style=" max-width: 150px;"
                  :items="option_filter"
                  label="Select"
                  v-model="searchCategory"
                  @change="search = ''"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
                <v-text-field
                  :disabled="!searchCategory"
                  v-model="search"
                  label="Search"
                  class="ma-2"
                  single-line
                  hide-details
                  v-if="searchCategory != 'payment_at'"
                >
                </v-text-field>
                <v-menu
                  ref="menuPickDate"
                  v-model="menuPickDate"
                  :close-on-content-click="false"
                  :return-value.sync="search"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  v-if="searchCategory == 'payment_at'"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="search"
                      label="Picker in menu"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      class="ma-2"
                      single-line
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="search" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menuPickDate = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menuPickDate.save(search)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>

                <v-btn
                  :disabled="!search"
                  class="mt-5"
                  small
                  color="primary"
                  @click="searchButton"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn
                  v-if="searchValue"
                  class="mt-5 ml-1"
                  dark
                  small
                  color="red"
                  @click="clearSearchButton"
                  >Clear</v-btn
                >
              </div>
            </v-card-title>
            <!-- <v-data-table
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100, -1]}"
      :options="{'itemsPerPage':50}"
    > -->
            <v-data-table
              mobile-breakpoint
              :headers="headers"
              :items="table"
              :loading="loadTable"
              loading-text="Loading... Please wait"
              @current-items="getFiltered"
              ref="vTable"
              :height="tableProps.tableHeight"
              fixed-header
              :options.sync="options"
              :server-items-length="totalDataTable"
              :page="page"
              :pageCount="numberOfPages"
              single-expand
              show-expand
              :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
            >

            <template v-slot:[`item.payment_pool`]="{ item }">
              <span v-if="item.payment_pool !=null">{{ item.payment_pool.pool_name  }}</span>
            </template>

              <template v-slot:[`header.payment_type`]="{ header }">
                <v-select
                  style=" font-size:10px;"
                  :items="optionPaymentType"
                  :label="header.text"
                  v-model="valuePaymentType"
                  @change="getList"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
              </template>

              <!-- <template v-slot:[`item.business_unit`]="{ item }">
                <span v-if="item.payment_driver_business_type == 1">TAXI</span>
                <span v-else-if="item.payment_driver_business_type == 2"
                  >RENTAL</span
                >
                <span v-else-if="item.payment_driver_business_type == 3"
                  >RENTAL OWNERSHIP</span
                >
              </template> -->
              <template v-slot:[`item.payment_type`]="{ item }">
                <span v-if="item.payment_type == 1">Driver DP</span>
                <span v-else-if="item.payment_type == 2">Weekly Payment</span>
                <span v-else-if="item.payment_type == 3">Additional Fee</span>
              </template>
              <template v-slot:[`item.driver_name`]="{ item }">
                <span v-if="item.payment_driver">{{
                  item.payment_driver.driver_name
                }}</span>
              </template>
              <template v-slot:[`item.ref_no`]="{ item }">
                <span v-if="item.payment_type == 1 && item.payment_ref">{{
                  item.payment_ref.driver_dp_doc_no
                }}</span>
                <span v-else-if="item.payment_type == 2 && item.payment_ref">{{
                  item.payment_ref.spj_no
                }}</span>
                <span v-else-if="item.payment_type == 3 && item.payment_ref">{{
                  item.payment_ref.driver_additional_fee_no
                }}</span>
              </template>
              <template v-slot:[`item.door_plate_no`]="{ item }">
                <span v-if="item.payment_type == 2 && item.payment_ref && item.payment_ref.pko && item.payment_ref.pko.vehicle">{{
                  item.payment_ref.pko.vehicle.vehicle_door_no +
                    "/" +
                    item.payment_ref.pko.vehicle.vehicle_plate_no
                }}</span>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td class="pa-5" :colspan="headers.length">
                  Payment Detail:
                  <button @click="generateReport(item.id)">Download receipt</button>
                  <md-table class="ma-5">
                    <md-table-row>
                      <md-table-head style="text-align: center;"
                        ><b>Payment Method</b></md-table-head
                      >
                      <md-table-head style="text-align: center;"
                        ><b>Billing Amount</b></md-table-head
                      >
                      <md-table-head style="text-align: center;"
                        ><b>Payment Amount</b></md-table-head
                      >
                      <md-table-head
                        style="text-align: center;"
                        v-if="item.payment_method == 2"
                        ><b>Transfer No.</b></md-table-head
                      >
                      <md-table-head style="text-align: center;"
                        ><b>Remarks</b></md-table-head
                      >
                    </md-table-row>
                    <md-table-row>
                      <md-table-head style="text-align: center;">
                        <span v-if="item.payment_method === 1">Cash</span>
                        <span v-else-if="item.payment_method === 2"
                          >Bank Transfer</span
                        >
                        <span v-else-if="item.payment_method === 3"
                          >EDC Payment</span
                        >
                        <span v-else-if="item.payment_method === 4"
                          >Virtual Account</span
                        >
                      </md-table-head>
                      <md-table-head style="text-align: center;">
                        <span style="float:left;">Rp.</span>
                        <span style="float:right;">{{
                          formatPrice(item.payment_billing_amount)
                        }}</span>
                      </md-table-head>
                      <md-table-head style="text-align: center;">
                        <span style="float:left;">Rp.</span>
                        <span style="float:right;">{{
                          formatPrice(item.payment_receive_amount)
                        }}</span>
                      </md-table-head>
                      <md-table-head
                        style="text-align: center;"
                        v-if="item.payment_method == 2"
                        >{{ item.payment_transfer_no }}</md-table-head
                      >
                      <md-table-head>{{ item.payment_remark }}</md-table-head>
                    </md-table-row>
                  </md-table>
                </td>
                
                <vue-html2pdf
                
                  style="visibility: collapse;"
                  :show-layout="false"
                  :float-layout="false"
                  :enable-download="true"
                  :preview-modal="false"
                  :paginate-elements-by-height="1400"
                  :filename="item.payment_no +'-'+ item.payment_driver.driver_name"
                  :pdf-quality="2"
                  :manual-pagination="false"
                  pdf-format="a4"
                  pdf-orientation="portrait"
                  pdf-content-width="800px"
          
                
                  :ref="'html2Pdf-'+item.id"
              >
                  <section slot="pdf-content">
                    <div style="margin: 5%;">
                      <table style="width: 100%; margin-bottom: 3%;">
                      <tr>
                        <!-- require("@/assets/images/charged_logo.png") -->
                        <td style=" color:#7030a0;text-align: center;">
                          <img src="../../../../assets/images/charged_logo_full.png" alt=""/>
                          <!-- <img></img> -->
                        </td>
                      </tr>
                      <tr>
                        <td style=" color:#7030a0;text-align: center;"><b>Receipt</b></td>
                      </tr>
                    </table>
                    <table style="width: 100%; border-collapse: collapse;border:1px solid black;">
                      <tr style="border-bottom:1px solid black;">
                        <td style="padding-left: 1%;"><span><b>Driver Name : </b></span><span style="color:#7030a0;"><b>{{ item.payment_driver.driver_name }}</b></span></td>
                      </tr>
                      <tr style="border-bottom:1px solid black;">
                        <td style="padding-left: 1%;border-right:1px solid black;">
                          <span><b>Pay No</b></span>
                          <br/>
                          <span style="color:#7030a0;"><b>{{ item.payment_no }}</b></span>
                        </td>
                        <td style="padding-left: 1%;">
                          <span><b>Payment Method</b></span>
                          <br/>
                          <span v-if="item.payment_method === 1"  style="color:#7030a0;"><b>Cash</b></span>
                        <span v-else-if="item.payment_method === 2"  style="color:#7030a0;"
                          ><b></b>Bank Transfer</span
                        >
                        <span v-else-if="item.payment_method === 3"  style="color:#7030a0;"
                          ><b>EDC Payment</b></span
                        >
                        <span v-else-if="item.payment_method === 4"  style="color:#7030a0;"
                          ><b>Virtual Account</b></span
                        >
                        </td>
                      </tr>
                      <tr style="border-bottom:1px solid black;">
                        <td style="padding-left: 1%;border-right:1px solid black;">
                          <span><b>Transfer No</b></span>
                          <br/>
                          <span v-if="item.payment_transfer_no" style="color:#7030a0;"><b>{{ item.payment_transfer_no }} </b></span>
                          <span v-else style="color:#ffffff00;">blank</span>
                        </td>
                        <td style="padding-left: 1%;">
                          <span><b>Created At :</b></span>
                          <br/>
                          <span style="color:#7030a0;"><b>{{ item.created_at }}</b></span>
                        </td>
                      </tr>
                      <tr style="border-bottom:1px solid black;">
                        <td style="padding-left: 1%;border-right:1px solid black;">
                          <span v-if="item.payment_type == 1"><b>DP No</b></span>
                          <span v-else-if="item.payment_type == 2"><b>SPJ No</b></span>
                          <span v-else-if="item.payment_type == 3"><b>Additional Fee No</b>Additional Fee</span>
                          <br/>
                           <span v-if="item.payment_type == 1" style="color:#7030a0;"><b>{{ item.payment_ref.driver_dp_doc_no }}</b></span>
                          <span v-else-if="item.payment_type == 2" style="color:#7030a0;"><b>{{ item.payment_ref.spj_no }}</b></span>
                          <span v-else-if="item.payment_type == 3" style="color:#7030a0;"><b>{{ item.payment_ref.driver_additional_fee_no }}</b></span>
                          <span v-else style="color:#ffffff00;">blank</span>
                        </td>
                        <td style="padding-left: 1%;">
                          <span><b>Status :</b></span>
                          <br/>
                          
                          <span v-if="item.payment_billing_amount == item.payment_receive_amount" style="color:#7030a0;"><b>Paid</b></span>
                          <span v-else style="color:#7030a0;"><b>Partial Paid</b></span>
                        </td>
                      </tr>
                      <tr style="border-bottom:1px solid black;">
                        <td style="padding-left: 1%;border-right:1px solid black;">
                          &nbsp;
                        </td>
                        <td style="padding-left: 1%;">
                          <span></span>
                        </td>
                      </tr>
                      <tr style="text-align: center;">
                        <td style="padding-left: 1%;"  colspan="2">
                          <span><b>Amount</b></span>
                          <br/>
                          <span style="color:#7030a0;">
                            <b>
                              <span >Rp. </span>
                              <span >{{
                                formatPrice(item.payment_receive_amount)
                              }}</span>
                            </b>
                          </span>
                        </td>
                      </tr>
                      
                    </table>
                    </div>
                    
                    
                  </section>
              </vue-html2pdf>
              </template>
              <!-- <template v-slot:[`item.actions`]="{ item }">
      
        <v-menu  offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            x-small
            v-bind="attrs"
            v-on="on"
            
          >
            <v-icon dark x-small>
              mdi-format-list-bulleted-square
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item    v-if="role.update"  @click="openEdit(item)">
            <v-list-item-title x-small>Edit</v-list-item-title>
          </v-list-item>
          <v-list-item  v-if="role.delete"  @click="deleteConfirmation(item.id)">
            <v-list-item-title >Delete</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template> -->
            </v-data-table>
          </v-card>
        </template>
      </resizable-page>
    </v-app>
    <modal ref="modalAddPage">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>Add Payment</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseAdd()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <add-payment />
      </template>
    </modal>
    
  </div>
  
</template>

<script>
import vuetify from "@/plugins/vuetify";
import AddPayment from "@/pages/Dashboard/Fms/Cashier/AddCPage.vue";
import { Modal } from "@/components";
import JsonExcel from "vue-json-excel";
import { ResizablePage } from "@/components";
import Swal from "sweetalert2";
import VueHtml2pdf from 'vue-html2pdf'

export default {
  components: {
    downloadExcel: JsonExcel,
    ResizablePage,
    Modal,
    "add-payment": AddPayment,
    VueHtml2pdf,
  },
  vuetify,
  data() {
    return {
      SwallAllExport: null,
      loadingDataExport: false,
      mounted: true,
      componentKeyMenuRange: 0,
      menu_range: false,
      date_list: null,
      date_range_list: null,
      date_list_show: null,
      date_range_list_show: null,
      clearButtonDateRange: 'none',
      optionPaymentType: [
        { text: "All", value: "" },
        { text: "Driver DP", value: "1" },
        { text: "Weekly Payment", value: "2" },
        { text: "Additional Fee", value: "3" },
      ],
      valuePaymentType: "",
      //optionBusinessUnit:null,
      
      searchValue: null,
      searchCategory: null,
      option_filter: [
        { text: "Payment No.", value: "payment_no" },
        { text: "Driver Name", value: "driver_name" },
        { text: "Ref No.", value: "ref_no" },
        // { text: "Payment At", value: "payment_at" },
        { text: "Cashier", value: "cashier" },
      ],
      page: 1,
      totalDataTable: 0,
      numberOfPages: 0,
      loadTable: false,
      role: "",
      search: "",
      options: {},
      headers: [
        { text: "", value: "data-table-expand" },
        
        {
          text: "Payment No.",
          value: "payment_no",
          align: "center",
          width: "150",
        },
        { text: "Driver Name", value: "driver_name", width: "150" },
        {
          text: "Payment type",
          value: "payment_type",
          align: "center",
          sortable: false,
          width: "150",
        },
        { text: "Ref No.", value: "ref_no", align: "center", width: "220" },
        {
          text: "Door/Plate No.",
          value: "door_plate_no",
          align: "center",
          sortable: false,
          width: "200",
        },
        {
          text: "Due Date",
          value: "payment_ref.spj_due_date",
          align: "center",
          sortable: false,
          width: "120",
        },
        {
          text: "Payment At",
          value: "payment_at",
          align: "center",
          width: "150",
        },
        { text: "Pool", value: "payment_pool" },
        { text: "Cashier", value: "payment_cashier" },
        { text: "Created At", value: "created_at", width:'200' },
        // { text: 'Actions', value: 'actions', align: 'center', sortable: false },
      ],
      table: [],
      worksheetName: "Payment",
      fileName: "Payment.xls",
      exportAllData: [],
      exportDisplayedPage: [],
      exportAllFitered: [],
      exportAll: [],
      menuPickDate: false,
      field_export: {
        no: "no",
        payment_no: "payment_no",
        driver_name: "driver_name",
        payment_type: "payment_type",
        ref_no: "ref_no",
        door_no: "door_no",
        plate_no: "plate_no",
        due_date: "due_date",
        payment_at: "payment_at",
        payment_cashier: "payment_cashier",
        payment_method: "payment_method",
        payment_receive_amount: "payment_receive_amount",
        payment_billing_amount: "payment_billing_amount",
        payment_remark: "payment_remark",
        created_at: "created_at",
        updated_at: "updated_at",
      },
    };
  },
  watch: {
    date_range_list: function(nv, ov) {
      console.log(nv)
      if(nv){
        this.date_range_list_show = nv.join(' ~ ')
        
      }
      else{
        this.date_range_list_show = ""
      }
    },
    options: {
      handler() {
        if (!this.mounted) {
          this.getList();
        }
      },
    },
    deep: true,
  },
  async mounted() {
    //get list role dan permission current user
    this.role = await this.$store.getters["role_permission/route_filter"];

    // await this.$store.dispatch("fms_business_unit/list");
    // this.optionBusinessUnit = await this.$store.getters["fms_business_unit/list"]
    // this.optionBusinessUnit.unshift({business_unit_name:"All",id:0});
    this.getList();
    this.mounted = false;
    this.tasksDone = 35
  },
  methods: {
    // ambil data yang dibutuhkan

    async getList() {
      this.loadTable = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      console.log(this.options);
      let pageNumber = page;

      console.log(itemsPerPage);
      let itemsPerPageNumber = itemsPerPage;

      var query = { page: { number: pageNumber, size: itemsPerPageNumber } };

      if (sortBy.length != 0) {
        var sort = sortBy[0];
        if (sortDesc[0]) {
          sort = "-" + sortBy[0];
        }
        query.sort = sort;
      }

      if (this.searchValue && this.searchCategory) {
        if (query.filter) {
          Object.assign(query.filter, {
            [this.searchCategory]: this.searchValue,
          });
        } else {
          query.filter = { [this.searchCategory]: this.searchValue };
        }
      }
      
      console.log(this.valuePaymentType);
      if (this.valuePaymentType != "") {
        if (query.filter) {
          Object.assign(query.filter, { payment_type: this.valuePaymentType });
        } else {
          query.filter = { payment_type: this.valuePaymentType };
        }
      }

      if (this.date_range_list) {
        if (query.filter) {
          Object.assign(query.filter, {
            ['payment_at']: this.date_range_list.toString(),
          });
        } else {
          query.filter = { ['payment_at']: this.date_range_list.toString() };
        }
      }


      await this.$store.dispatch("fms_cashier/list", query);
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
      this.table = await this.$store.getters["fms_cashier/list"];
      var pageMeta = await this.$store.getters["fms_cashier/page"];
      // }
      // else{
      //   this.table = []
      // }
      console.log(pageMeta);
      this.totalDataTable = pageMeta.total;
      this.numberOfPages = pageMeta["to"];
      this.loadTable = false;
    },

    generateReport (id) {
            this.$refs["html2Pdf-" + id].generatePdf()
        },
    addData() {
      this.$refs.modalAddPage.openModal();
    },

    modalCloseAdd() {
      this.$refs.modalAddPage.closeModal();
      this.getList();
    },

    formatPrice(value) {
      let val = (value / 1).toFixed().replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    searchButton() {
      this.searchValue = this.search;
      this.getList();
    },
    clearSearchButton() {
      this.searchValue = null;
      this.search = null;
      this.searchCategory = null;
      this.getList();
    },

    getFiltered(data) {
      this.exportDisplayedPage = this.dataExport(data);
      // if(this.$refs.vTable){
      //   this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
      // }
      // else{
      //   this.exportAllFitered = this.dataExport(this.table)
      // }
    },

    //fungsi untuk pinda ke page tambah
    // addData() {
    //   // panggil page add data
    //   this.$router.push({ name: "Add Cashier" });
    // },
    openEdit(id) {
      // panggil edit page
      this.$router.push({ name: "Edit Cashier", params: { id: id } });
    },
   

    async exportAllXls(){
      //buka swal
     Swal.fire({
                title: 'Please Wait !',
                html: "<div id='save-popup-icon'></div><span id='save-popup-message'></span>",
                allowOutsideClick: false,
                showCancelButton: true,
                onBeforeOpen: () => {
                    Swal.showLoading()
                },
                customClass: {
                  actions: 'vertical-buttons-sweetalert',
                  cancelButton: 'top-margin-sweetalert'
                }
            }).then((result) => {
              if (result.isDismissed) {
                return
              }
            })
     //query pertama
      var query = { page: { number: 1, size: 1 } };
            await this.$store.dispatch("fms_cashier/list", query);
            var pageMeta = await this.$store.getters["fms_cashier/page"];
            var dataFirst = await this.$store.getters["fms_cashier/list"]

            //ambil data paling akhir
            var query = { page: { number: pageMeta['last-page'], size: 1 } };
            await this.$store.dispatch("fms_cashier/list", query);
            var datalast = await this.$store.getters["fms_cashier/list"]

            //set tanggal pertama dan tanggal terakhir
            var startDate = this.$moment(dataFirst[0].created_at.substring(0,7));
            var endDate = this.$moment(datalast[0].created_at.substring(0,7));
            var listRange = [endDate.format('YYYY-MM')];

            //while untuk mendapatkan list bulan berdasarkan tanggal awal dan akhir
            while (endDate.isBefore(startDate)) {
              endDate = endDate.add(1, 'month');
              listRange.push(endDate.format('YYYY-MM'));
            }
            console.log(listRange)
            //untuk menghitung progress export perbulanya
            var countMonth = 1;
            //loop berdasarkan list bulan
            for (const yearMonth of listRange) { 

                console.log(yearMonth);

                //ambil data berdasarkan bulan dengan di pecah per 100
                var query = { page: { number: 1, size: 100 } };
                query.filter = { created_at_month_year: yearMonth };
                await this.$store.dispatch("fms_cashier/list", query);
               var dataAll  = await this.$store.getters["fms_cashier/list"]
                // console.log(dataAll)
                var pageMeta = await this.$store.getters["fms_cashier/page"];
                // console.log(pageMeta['last-page'])
                //loop berdasarkan jumlah page
                for(let i=2; i < pageMeta['last-page'] + 1; i++){
                  
                  console.log('tahap '+i)
                  var query = { page: { number: i, size: 100 } };
                  query.filter = { created_at_month_year: yearMonth };
                  await this.$store.dispatch("fms_cashier/list", query);
                  var dataloop = await this.$store.getters["fms_cashier/list"]
                  dataAll = dataAll.concat(dataloop)

                  //update tampilan informasi di swal untuk memunculkan progress
                  let popupTextElement = document.getElementById("save-popup-message");
                   if(popupTextElement){
                     let export_text = "Export "+countMonth+"/"+listRange.length+" Month"

                     let export_percentage = (i/pageMeta['last-page']*100).toFixed(2)+"%"
                   popupTextElement.innerHTML = export_text+"</br> <progress  value='"+i+"' max='"+pageMeta['last-page']+"'></progress>";
                   }
                   else{
                     //bagian ini terpanggil jika tombol cancel di swal tertekan
                     this.fileName = "Payment.xls"
                     return
                   }
                }
                //set file name berdsarkan buan dan tahun
                this.fileName = "Payment "+yearMonth +".xls"
                this.exportAllData = dataAll
                //click tombol component export to excell
                const elem = this.$refs.btnDownloadAllExcell
                elem.click()
                countMonth++;


                
            }
            //tutup swal jika prosess looping selesai
            //  Swal.close();
             this.SwallAllExport = Swal;
             //set kembali ke default nama filename
            this.fileName = "Payment.xls"
            
    },

    async exportAllFilteredXls(){
      //buka swal
      
      this.loadingAllExport = true
     Swal.fire({
                title: 'Please Wait !',
                html: "<div id='save-popup-icon'></div><span id='save-popup-message'></span>",
                allowOutsideClick: false,
                showCancelButton: true,
                onBeforeOpen: () => {
                    Swal.showLoading()
                },
                customClass: {
                  actions: 'vertical-buttons-sweetalert',
                  cancelButton: 'top-margin-sweetalert'
                }
            }).then((result) => {
              if (result.isDismissed) {
                return
              }
            })
            //query pertama
            var query = {};
          
            const {sortBy, sortDesc } = this.options;

                if (sortBy.length != 0) {
                    var sort = sortBy[0];
                    if (sortDesc[0]) {
                      sort = "-" + sortBy[0];
                    }
                    query.sort = sort;
                  }

                if (this.searchValue && this.searchCategory) {
                   if (query.filter) {
                    Object.assign(query.filter, {
                      [this.searchCategory]: this.searchValue,
                    });
                  } else {
                    query.filter = { [this.searchCategory]: this.searchValue };
                  }
                }

                
                console.log(this.valuePaymentType);
                if (this.valuePaymentType != "") {
                  if (query.filter) {
                    Object.assign(query.filter, {
                      payment_type: this.valuePaymentType,
                    });
                  } else {
                    query.filter = { payment_type: this.valuePaymentType };
                  }
                }

                if (this.date_range_list) {
                  if (query.filter) {
                    Object.assign(query.filter, {
                      ['payment_at']: this.date_range_list.toString(),
                    });
                  } else {
                    query.filter = { ['payment_at']: this.date_range_list.toString() };
                  }
                }

                //ambil data berdasarkan bulan dengan di pecah per 100
                query.page = { number: 1, size: 100 };
                await this.$store.dispatch("fms_cashier/list", query);
               var dataAll  = await this.$store.getters["fms_cashier/list"]
                // console.log(dataAll)
                var pageMeta = await this.$store.getters["fms_cashier/page"];
                // console.log(pageMeta['last-page'])
                //loop berdasarkan jumlah page
                if(pageMeta.total > 10000){
                  var count_100 = 1;
                  var part_count = 1;
                  var total_progress_start = pageMeta['last-page'];
                  var total_progress = 100;
                  var progress = 1;
                  var total_part = (!Number.isInteger(pageMeta.total/10000))?parseInt((pageMeta.total/10000).toFixed(0))+1:pageMeta.total/10000
                  for(let i=2; i < pageMeta['last-page'] + 1; i++){
                  
                  console.log('tahap '+i)
                  query.page = { number: i, size: 100 };
                  await this.$store.dispatch("fms_cashier/list", query);
                  var dataloop = await this.$store.getters["fms_cashier/list"]
                  dataAll = dataAll.concat(dataloop)

                  //update tampilan informasi di swal untuk memunculkan progress
                  let popupTextElement = document.getElementById("save-popup-message");
                   if(popupTextElement){
                    
                     let export_text = "Export "+part_count+"/"+total_part+" Part"
                     let export_percentage = (i/pageMeta['last-page']*100).toFixed(2)+"%"
                      popupTextElement.innerHTML = export_text+"</br> <progress  value='"+progress+"' max='"+total_progress+"'></progress>";
                   }
                   else{
                     //bagian ini terpanggil jika tombol cancel di swal tertekan
                     return
                   }
                   progress++;
                   count_100++;
                   if(count_100 == 100){
                    count_100 = 0;
                    this.fileName = "Payment part"+part_count+".xls"
                    this.exportAllData = dataAll
                    const elem = this.$refs.btnDownloadAllFilteredExcell
                    elem.click()
                    
                    dataAll = []
                    part_count++;
                    total_progress_start = total_progress_start - 100
                    if((total_progress_start/100).toFixed(0) == 0){
                      total_progress = total_progress_start
                    }
                    else{
                       total_progress = 100
                    }
                    progress = 0
                   }

                }
                 this.fileName = "Payment part"+part_count+".xls"
                this.exportAllData = dataAll
                //click tombol component export to excell
                
                this.SwallAllExport = Swal;
                const elem = this.$refs.btnDownloadAllFilteredExcell
                elem.click()
                }
                else{
                for(let i=2; i < pageMeta['last-page'] + 1; i++){
                  
                  console.log('tahap '+i)
                  query.page = { number: i, size: 100 };
                  await this.$store.dispatch("fms_cashier/list", query);
                  var dataloop = await this.$store.getters["fms_cashier/list"]
                  dataAll = dataAll.concat(dataloop)

                  //update tampilan informasi di swal untuk memunculkan progress
                  let popupTextElement = document.getElementById("save-popup-message");
                   if(popupTextElement){

                     let export_percentage = (i/pageMeta['last-page']*100).toFixed(2)+"%"
                      popupTextElement.innerHTML = "<progress  value='"+i+"' max='"+pageMeta['last-page']+"'></progress>";
                   }
                   else{
                     //bagian ini terpanggil jika tombol cancel di swal tertekan
                     return
                   }
                }
                this.exportAllData = dataAll
                
                this.SwallAllExport = Swal;
                //click tombol component export to excell
                const elem = this.$refs.btnDownloadAllFilteredExcell
                elem.click()

              }
            

            
    },

 




    async dataExportBefore(type) {
      if (this.table.length != 0) {
        if (type == "filter") {
          var query = {};
          
      const {sortBy, sortDesc } = this.options;

          if (sortBy.length != 0) {
              var sort = sortBy[0];
              if (sortDesc[0]) {
                sort = "-" + sortBy[0];
              }
              query.sort = sort;
            }

            if (this.searchValue && this.searchCategory) {
                   if (query.filter) {
                    Object.assign(query.filter, {
                      [this.searchCategory]: this.searchValue,
                    });
                  } else {
                    query.filter = { [this.searchCategory]: this.searchValue };
                  }
                }

          
          console.log(this.valuePaymentType);
          if (this.valuePaymentType != "") {
            if (query.filter) {
              Object.assign(query.filter, {
                payment_type: this.valuePaymentType,
              });
            } else {
              query.filter = { payment_type: this.valuePaymentType };
            }
          }

          if (this.date_range_list) {
            if (query.filter) {
              Object.assign(query.filter, {
                ['payment_at']: this.date_range_list.toString(),
              });
            } else {
              query.filter = { ['payment_at']: this.date_range_list.toString() };
            }
          }

          await this.$store.dispatch("fms_cashier/list", query);
          return this.dataExport(await this.$store.getters["fms_cashier/list"]);
        }
      }
    },

    changeDateRange(){
      this.getList()
      
        this.worksheetName= "Payment "+ this.date_range_list_show
        this.clearButtonDateRange = 'block'
    },

    clearDateRangeButton() {
       this.componentKeyMenuRange += 1;
       this.date_range_list=null
       this.date_range_list_show=null
       this.clearButtonDateRange = 'none'
       this.getList()
    },

    dataExport(data) {
      var dataReturn = [];

      data.forEach((value, index) => {
        var payment_type = "";

        if (value.payment_type == 1) {
          payment_type = "Driver DP";
        } else if (value.payment_type == 2) {
          payment_type = "Weekly Payment";
        }

        var ref_no = "";
        if (value.payment_type == 1  && value.payment_ref) {
          ref_no = value.payment_ref.driver_dp_doc_no;
        } else if (value.payment_type == 2  && value.payment_ref) {
          ref_no = value.payment_ref.spj_no;
        }

        var payment_method = "";
        if (value.payment_method === 1) {
          payment_method = "Cash";
        } else if (value.payment_method === 2) {
          payment_method = "Bank Transfer";
        } else if (value.payment_method === 3) {
          payment_method = "EDC Payment";
        } else if (value.payment_method === 4) {
          payment_method = "Virtual Account";
        }

        var data = {
          no: index + 1,
          payment_no: value.payment_no,
          driver_name: (value.payment_driver)? value.payment_driver.driver_name : null,
          payment_type: payment_type,
          ref_no: ref_no,
          door_no: (value.payment_type == 2 && value.payment_ref && value.payment_ref.pko && value.payment_ref.pko.vehicle ) ? value.payment_ref.pko.vehicle.vehicle_door_no:null,
          plate_no: (value.payment_type == 2 && value.payment_ref && value.payment_ref.pko && value.payment_ref.pko.vehicle ) ? value.payment_ref.pko.vehicle.vehicle_plate_no:null,
          due_date: (value.payment_type == 2 && value.payment_ref) ? value.payment_ref.spj_due_date:null,
          payment_at: value.payment_at,
          payment_cashier: value.payment_cashier,
          payment_method: payment_method,
          payment_receive_amount: value.payment_receive_amount,
          payment_billing_amount: value.payment_billing_amount,
          payment_remark: value.payment_remark,
          created_at: value.created_at,
          updated_at: value.updated_at,
        };
        dataReturn.push(data);
      });
       if(this.SwallAllExport){
        this.SwallAllExport.close();
        this.SwallAllExport = null
      }
      console.log("dataReturn")
      return dataReturn;
    },
  },
};
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
  font-size: 0.8rem;
}
.vertical-buttons-sweetalert {
  flex-direction: column;
}

.top-margin-sweetalert {
  margin-top: .5em;
}


td:empty:after, th:empty:after {
  content: "\00a0";
}

</style>
